export const formatCentsToCurrency = (cents: number, currencyCode: string, locale: string = 'en-US') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    trailingZeroDisplay: 'stripIfInteger',
  } as Intl.NumberFormatOptions).format(cents / 100);
};
